import { resolveTabIn, searchWithTabFor } from '../../util_components/page_tabs/page_tabs';
import type { TabDef as GenericTabDef } from '../../util_components/page_tabs/page_tabs';

export type PageTab = 'tasks' | 'generation' | 'report' | 'sales_users';

export type TabDef = GenericTabDef<PageTab>;

export const DEFAULT_TAB: PageTab = 'tasks';

const ALL_TABS: TabDef[] = [
  { id: 'tasks', label: 'Tasks' },
  { id: 'generation', label: 'Task generation' },
  { id: 'report', label: 'Instant task report' },
  { id: 'sales_users', label: 'Sales users' }
];

// The report and sales-users tabs are SUPER_USER-only, so they are absent
// (not disabled) otherwise.
export const tabList = (canViewReport: boolean, canManageSalesUsers = false): TabDef[] =>
  ALL_TABS.filter(
    (t) => (t.id !== 'report' || canViewReport) && (t.id !== 'sales_users' || canManageSalesUsers)
  );

export const resolveTab = (
  search: string | URLSearchParams,
  canViewReport: boolean,
  canManageSalesUsers = false
): PageTab => resolveTabIn(tabList(canViewReport, canManageSalesUsers), DEFAULT_TAB, search);

export const searchWithTab = (search: string | URLSearchParams, tab: PageTab): string =>
  searchWithTabFor(DEFAULT_TAB, search, tab);
